import $apiPublic from '@/api/apiPublic';
import $apiPrivate from '@/api/apiPrivate';

const signup = async params => {
  const response = await $apiPublic.post('clients', params);
  return response;
};

const checkSignupOtp = async params => {
  const response = await $apiPublic.post('clients/verify_email', params);
  return response;
};

const resendSignupOtp = async email => {
  const response = await $apiPublic.post('clients/resend_email_verification', {
    email,
  });
  return response;
};

const login = async params => {
  const response = await $apiPublic.post('auth/login', params);
  return response;
};

const checkLoginOtp = async params => {
  const response = await $apiPublic.post('auth/verify_2fa', params);
  return response;
};

const logout = async () => {
  const response = await $apiPrivate.post('auth/logout');
  return response;
};

const forgotPassword = async email => {
  const response = await $apiPublic.post('auth/forgot_password', { email });
  return response;
};

const checkForgotOtp = async params => {
  const response = await $apiPublic.get('auth/verify_reset_code', { params });
  return response;
};

const passwordReset = async params => {
  const response = await $apiPublic.post('auth/reset_password', params);
  return response;
};

const refreshToken = async () => {
  const response = await $apiPublic.post('auth/refresh');
  return response;
};

export default {
  signup,
  checkSignupOtp,
  resendSignupOtp,
  login,
  checkLoginOtp,
  logout,
  forgotPassword,
  checkForgotOtp,
  passwordReset,
  refreshToken,
};
